import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ontos-code" }
const _hoisted_3 = {
  key: 1,
  class: "text-body-2 text-grey"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "ontos-code" }
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 text-grey"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "ontos-code" }
const _hoisted_9 = {
  key: 0,
  class: "text-body-2 text-grey"
}
const _hoisted_10 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_workspace_closure_dialog = _resolveComponent("ontos-workspace-closure-dialog")!
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!
  const _component_ontos_view_info = _resolveComponent("ontos-view-info")!
  const _component_ontos_markdown_excerpt = _resolveComponent("ontos-markdown-excerpt")!
  const _component_ontos_info_row = _resolveComponent("ontos-info-row")!
  const _component_markdown_viewer = _resolveComponent("markdown-viewer")!
  const _component_ontos_section = _resolveComponent("ontos-section")!
  const _component_ontos_class_diagram = _resolveComponent("ontos-class-diagram")!
  const _component_ontos_state_list = _resolveComponent("ontos-state-list")!
  const _component_ontos_colored_entry_list = _resolveComponent("ontos-colored-entry-list")!
  const _component_ontos_members_panel = _resolveComponent("ontos-members-panel")!
  const _component_ontos_tabbed_section = _resolveComponent("ontos-tabbed-section")!
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_ontos_design_dialogs = _resolveComponent("ontos-design-dialogs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_ontos_class_dialog = _resolveComponent("ontos-class-dialog")!
  const _component_ontos_workflow_dialog = _resolveComponent("ontos-workflow-dialog")!
  const _component_ontos_domain_dialog = _resolveComponent("ontos-domain-dialog")!
  const _component_ontos_roles_dialog = _resolveComponent("ontos-roles-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, _mergeProps(_ctx.heading, { level: 1 }), {
              actions: _withCtx(() => [
                (_ctx.can('admin'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ontos_header_action, {
                        icon: "mdi-archive-arrow-down-outline",
                        label: _ctx.$tt('workspace-close'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asking = 'closure'))
                      }, null, 8, ["label"]),
                      _createVNode(_component_ontos_header_action, {
                        icon: "mdi-delete",
                        label: _ctx.$tt('delete'),
                        color: "error",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.asking = 'delete'))
                      }, null, 8, ["label"])
                    ], 64))
                  : (_ctx.is('admin'))
                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                        key: 1,
                        icon: "mdi-archive-arrow-up-outline",
                        label: _ctx.$tt('workspace-reopen'),
                        color: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.asking = 'closure'))
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 16),
            (_ctx.asking === 'closure')
              ? (_openBlock(), _createBlock(_component_ontos_workspace_closure_dialog, {
                  key: 0,
                  closing: _ctx.can('admin'),
                  name: _ctx.workspace.title,
                  onConfirmed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClosureConfirmed())),
                  onCancelled: _cache[4] || (_cache[4] = ($event: any) => (_ctx.asking = null))
                }, null, 8, ["closing", "name"]))
              : _createCommentVNode("", true),
            (_ctx.asking === 'delete')
              ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
                  key: 1,
                  title: _ctx.$tt('workspace-delete-confirm', {name: _ctx.workspace.title}),
                  message: _ctx.$tt('workspace-delete-explain'),
                  actions: _ctx.deleteActions(),
                  onPick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDeletePicked($event))),
                  onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.asking = null))
                }, null, 8, ["title", "message", "actions"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ontos_tabbed_section, {
              tabs: _ctx.tabs,
              opens: _ctx.tabOpens,
              routed: ""
            }, {
              controls: _withCtx(({tab}) => [
                (tab === 'info' && _ctx.can('admin'))
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 0,
                      icon: "mdi-pencil",
                      color: "primary",
                      label: _ctx.$tt('edit'),
                      to: {name: 'edit-system', params: {system: _ctx.params.system}}
                    }, null, 8, ["label", "to"]))
                  : (tab === 'collections' && _ctx.can('designer'))
                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                        key: 1,
                        icon: "mdi-plus",
                        color: "primary",
                        label: _ctx.$tt('collection-create'),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.creatingIdea = true))
                      }, null, 8, ["label"]))
                    : (tab === 'workflows' && _ctx.can('designer'))
                      ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                          key: 2,
                          icon: "mdi-plus",
                          color: "primary",
                          label: _ctx.$tt('workflow-create-short'),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.creatingWorkflow = true))
                        }, null, 8, ["label"]))
                      : (tab === 'domains' && _ctx.can('designer'))
                        ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                            key: 3,
                            icon: "mdi-plus",
                            color: "primary",
                            label: _ctx.$tt('domain-create'),
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.creatingDomain = true))
                          }, null, 8, ["label"]))
                        : (tab === 'roles' && _ctx.can('designer'))
                          ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                              key: 4,
                              icon: "mdi-pencil",
                              color: "primary",
                              label: _ctx.$tt('roles-edit'),
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editingRoles = true))
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true)
              ]),
              default: _withCtx(({tab}) => [
                (tab === 'info')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ontos_info_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ontos_view_info, {
                            title: _ctx.$tt('workspace-name')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.workspace.title), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]),
                          _createVNode(_component_ontos_view_info, {
                            title: _ctx.$tt('alias')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.workspace.alias), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]),
                          _createVNode(_component_ontos_view_info, {
                            title: _ctx.$tt('time-zone')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.timeZoneOf(_ctx.workspace)), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]),
                          (_ctx.description && _ctx.descriptionInline)
                            ? (_openBlock(), _createBlock(_component_ontos_view_info, {
                                key: 0,
                                title: _ctx.$tt('workspace-description')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ontos_markdown_excerpt, {
                                    value: _ctx.description,
                                    full: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.description && !_ctx.descriptionInline)
                        ? (_openBlock(), _createBlock(_component_ontos_section, {
                            key: 0,
                            title: _ctx.$tt('workspace-description'),
                            level: 3,
                            dense: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_markdown_viewer, {
                                initialValue: _ctx.description,
                                class: "ontos-inset mb-3"
                              }, null, 8, ["initialValue"])
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (tab === 'collections')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.workspace.ideas.length)
                          ? (_openBlock(), _createBlock(_component_ontos_class_diagram, {
                              key: 0,
                              workspace: _ctx.workspace,
                              expandable: "",
                              onOpen: _cache[11] || (_cache[11] = ($event: any) => (_ctx.open($event))),
                              onExpand: _cache[12] || (_cache[12] = ($event: any) => (_ctx.expanded = true))
                            }, null, 8, ["workspace"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$tt('collections-empty')), 1))
                      ], 64))
                    : (tab === 'workflows')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.workflows, (workflow, index) => {
                            return (_openBlock(), _createBlock(_component_ontos_state_list, {
                              key: workflow.alias,
                              states: workflow.states,
                              title: workflow.name,
                              level: 3,
                              dense: "",
                              divider: index > 0
                            }, {
                              subtitle: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(workflow.alias), 1)
                              ]),
                              actions: _withCtx(() => [
                                (_ctx.can('designer'))
                                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                                      key: 0,
                                      icon: "mdi-pencil",
                                      label: _ctx.$tt('edit'),
                                      onClick: ($event: any) => (_ctx.editingWorkflow = workflow)
                                    }, null, 8, ["label", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["states", "title", "divider"]))
                          }), 128)),
                          (!_ctx.workspace.workflows.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$tt('workflows-empty')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (tab === 'domains')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.domains, (domain, index) => {
                              return (_openBlock(), _createBlock(_component_ontos_colored_entry_list, {
                                key: domain.alias,
                                entries: domain.options,
                                title: domain.name,
                                level: 3,
                                dense: "",
                                divider: index > 0
                              }, {
                                subtitle: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_8, _toDisplayString(domain.alias), 1)
                                ]),
                                actions: _withCtx(() => [
                                  (_ctx.can('designer'))
                                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                                        key: 0,
                                        icon: "mdi-pencil",
                                        label: _ctx.$tt('edit'),
                                        onClick: ($event: any) => (_ctx.editingDomain = domain)
                                      }, null, 8, ["label", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["entries", "title", "divider"]))
                            }), 128)),
                            (!_ctx.workspace.domains.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$tt('domains-empty')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (tab === 'roles')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_ontos_colored_entry_list, {
                                entries: _ctx.roles,
                                header: false,
                                divider: false,
                                "empty-text": _ctx.$tt('roles-empty')
                              }, null, 8, ["entries", "empty-text"])
                            ]))
                          : (_openBlock(), _createBlock(_component_ontos_members_panel, {
                              key: 5,
                              workspace: _ctx.workspace,
                              onShowMessage: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                              onShowErrorMessage: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                            }, null, 8, ["workspace"]))
              ]),
              _: 1
            }, 8, ["tabs", "opens"]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.expanded,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.expanded) = $event)),
              fullscreen: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "expanded-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ontos_page_header, {
                          title: _ctx.$tt('collections'),
                          level: 2
                        }, {
                          controls: _withCtx(() => [
                            _createVNode(_component_ontos_dialog_actions, {
                              onClosed: _cache[15] || (_cache[15] = ($event: any) => (_ctx.expanded = false))
                            })
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "expanded-body" }, {
                      default: _withCtx(() => [
                        (_ctx.expanded)
                          ? (_openBlock(), _createBlock(_component_ontos_class_diagram, {
                              key: 0,
                              workspace: _ctx.workspace,
                              class: "expanded-diagram",
                              onOpen: _cache[16] || (_cache[16] = ($event: any) => (_ctx.open($event)))
                            }, null, 8, ["workspace"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.expanded)
                      ? (_openBlock(), _createBlock(_component_ontos_design_dialogs, _mergeProps({ key: 0 }, _ctx.designDialogs, _toHandlers(_ctx.designDialogListeners)), null, 16))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (!_ctx.expanded)
              ? (_openBlock(), _createBlock(_component_ontos_design_dialogs, _mergeProps({ key: 2 }, _ctx.designDialogs, _toHandlers(_ctx.designDialogListeners)), null, 16))
              : _createCommentVNode("", true),
            (_ctx.creatingIdea)
              ? (_openBlock(), _createBlock(_component_ontos_class_dialog, {
                  key: 3,
                  ref: "classDialog",
                  workspace: _ctx.workspace,
                  saving: _ctx.savingDesign,
                  onCreate: _cache[18] || (_cache[18] = ($event: any) => (_ctx.createCollection($event))),
                  onClosed: _cache[19] || (_cache[19] = ($event: any) => (_ctx.creatingIdea = false))
                }, null, 8, ["workspace", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.creatingWorkflow || _ctx.editingWorkflow)
              ? (_openBlock(), _createBlock(_component_ontos_workflow_dialog, {
                  key: 4,
                  workspace: _ctx.workspace,
                  workflow: _ctx.editingWorkflow,
                  saving: _ctx.savingDesign,
                  onCreate: _cache[20] || (_cache[20] = ($event: any) => (_ctx.createWorkflowFromDesign($event))),
                  onSave: _cache[21] || (_cache[21] = ($event: any) => (_ctx.saveEditedWorkflow($event))),
                  onClosed: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeWorkflowDialog()))
                }, null, 8, ["workspace", "workflow", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.creatingDomain || _ctx.editingDomain)
              ? (_openBlock(), _createBlock(_component_ontos_domain_dialog, {
                  key: 5,
                  workspace: _ctx.workspace,
                  domain: _ctx.editingDomain,
                  saving: _ctx.savingDesign,
                  onCreate: _cache[23] || (_cache[23] = ($event: any) => (_ctx.createDomainFromDesign($event))),
                  onSave: _cache[24] || (_cache[24] = ($event: any) => (_ctx.saveEditedDomain($event))),
                  onClosed: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeDomainDialog()))
                }, null, 8, ["workspace", "domain", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.editingRoles)
              ? (_openBlock(), _createBlock(_component_ontos_roles_dialog, {
                  key: 6,
                  roles: _ctx.workspace.roles || [],
                  "workspace-title": _ctx.workspace.title,
                  saving: _ctx.savingDesign,
                  onSave: _cache[26] || (_cache[26] = ($event: any) => (_ctx.saveRolesFromDesign($event))),
                  onClosed: _cache[27] || (_cache[27] = ($event: any) => (_ctx.editingRoles = false))
                }, null, 8, ["roles", "workspace-title", "saving"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}